import TeamPlanListUpdated from "src/scenes/subscription/team-plan-list-updated";
import PendingInvitesPlanList from "src/scenes/subscription/pending-invites-plan-list";
import React from "react";
import useApi from "src/utils/api/use-api";
import request from "src/utils/request";
import { Grid } from "@mui/material";

const ManagePlanListsWrapper = ({ subscription, setMembersAlreadyInPlan }) => {
    if (!subscription) return null;
    const planMembersApi = useApi(() => request(`/api/payments/${subscription.id}/members`));
    // TODO add search function
    return (
        <Grid container spacing={2} mb={8}>
            <Grid item md={12}>
                <TeamPlanListUpdated
                    subscription={subscription}
                    setMembersAlreadyInPlan={subscription && setMembersAlreadyInPlan}
                    planMembersApi={planMembersApi}
                />
            </Grid>
            <Grid item md={12}>
                <PendingInvitesPlanList
                    subscription={subscription}
                    planMembersApi={planMembersApi}
                />
            </Grid>
        </Grid>
    );
};
export default ManagePlanListsWrapper;
